import * as ga from "./ga";

export const isGoogleAnalyticsAvailable = () => {
    const gaObjectName = window.GoogleAnalyticsObject;
    return !!(gaObjectName && gaObjectName in window && window[gaObjectName] !== undefined);
};

export const setUpGoogleAnalytics = () => {
    window.GoogleAnalyticsObject = "ga";
    window.ga =
        window.ga ||
        // tslint:disable-next-line:only-arrow-functions
        function () {
            (window.ga.q = window.ga.q || []).push(arguments);
        };
    window.ga.l = +new Date();

    const asyncScript = document.createElement("script");
    asyncScript.async = true;
    asyncScript.src = "https://www.google-analytics.com/analytics.js";
    window.document.getElementsByTagName("head")[0].appendChild(asyncScript);
};

export const getGoogleAnalyticsObject = () => {
    if (!ga.isGoogleAnalyticsAvailable()) {
        ga.setUpGoogleAnalytics();
    }

    return window[window.GoogleAnalyticsObject!];
};

const osTrackerNamePrepend = "OSfea";

const getTracker = (gaObject: any, tid: string, trackerIndex: number) => {
    const name = `${osTrackerNamePrepend}${trackerIndex}`;
    if (gaObject.getByName && gaObject.getByName(name) === undefined) {
        gaObject("create", tid, "auto", name);
    }
    return name;
};

export const sendGoogleAnalyticsEvent = (tid: string, trackerIndex: number, event: any) => {
    const gaObject = getGoogleAnalyticsObject();
    const name = getTracker(gaObject, tid, trackerIndex);
    gaObject(`${name}.send`, event);
};
